import { type Control, useWatch } from 'react-hook-form';
import { Button, CircularProgress } from '@mui/material';

import { PageHeader } from '@components/PageHeader';
import { type PatientSchema } from '@/zod_schemas';

interface PatientHeaderProps {
  control: Control<PatientSchema>;
  isSubmitting: boolean;
}

const PatientHeader = ({ control, isSubmitting }: PatientHeaderProps) => {
  const sampleID = useWatch({
    control,
    name: 'name',
  });

  return (
    <PageHeader
      eyebrow="Clinical record"
      title={sampleID || 'New Patient'}
      description="Capture identity, demographics, phenotypes, and sample associations for this patient."
      actions={
        <Button type="submit" variant="contained" disabled={isSubmitting}>
          {isSubmitting ? (
            <CircularProgress size={22} color="inherit" />
          ) : (
            'Save'
          )}
        </Button>
      }
    />
  );
};

export default PatientHeader;
